import { connect } from 'react-redux';
import config from '../../../config';
import { getCreditableOptionsWithPlan, getLocalCreditableOptionsWithPlan } from '../../../modules/AvailableOption/selectors';
import { addOptionToNewOffer } from '../../../modules/NewOffer/actions';
import {
  getCreditableOptionsWithPlanWithZeroValues,
  getLocalCreditableOptionsWithPlanWithZeroValues,
  newOfferOptionsSelector,
  newOfferPeriodicitySelector,
  newOfferPriceSelector,
} from '../../../modules/NewOffer/selectors';
import PlanUniqueOffer from './PlanUniqueOffer';

const mapStateToProps = state => ({
  selectedOptions: newOfferOptionsSelector(state),
  creditableOptions: config.displayRoamingPlanSliders
    ? (config.addZeroOptionForEachService
        ? getLocalCreditableOptionsWithPlanWithZeroValues(state)
        : getLocalCreditableOptionsWithPlan(state))
    : (config.addZeroOptionForEachService
        ? getCreditableOptionsWithPlanWithZeroValues(state)
        : getCreditableOptionsWithPlan(state)),
  priceKey: 'taxIncludedAmount',
  totalPrice: newOfferPriceSelector(state),
  periodicity: newOfferPeriodicitySelector(state),
});

const mapDispatchToProps = {
  addOptionToNewOffer,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanUniqueOffer);
